import React, { Component } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { valueConverter_2 } from '../../util-functions/util-funtions'
class PreAndPostOpsoTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openIndex: null,
            dropRow: false,
            isPostCheck: true,
            isPreCheck: true,
            selectBoxDropDownOpen: false,
            isCategory: true,
            isBrand: false
        };
    }

    render() {
        return (

            <div className='pre-post-heading-and-table-container'>

                <div className='heading-and-filter-container'>

                    <span className='table-heading'>

                        {this.props.heading === 'absolute' ? 'Absolute Spends (Pre & Post OPSO)' : <span>Count of Activities (Pre & Post OPSO)<span style={{ color: 'red' }}>*</span></span>}

                    </span>

                    <span className='img-container'>

                        <img src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ selectBoxDropDownOpen: !this.state.selectBoxDropDownOpen }) }} alt='' />

                        {
                            this.state.selectBoxDropDownOpen ?

                                <ClickAwayListener onClickAway={() => { this.setState({ selectBoxDropDownOpen: false }) }}>

                                    <div className='selectbox-dropdown' ref={node => { this.node = node; }}>

                                        <span className='checkbox-label-container'>

                                            <input type='checkbox' className='check-box-scss' checked={this.state.isPreCheck}
                                                onChange={() => { this.setState({ isPreCheck: !this.state.isPreCheck }) }} />

                                            <label className='checkbox-label'
                                                onClick={() => { this.setState({ isPreCheck: !this.state.isPreCheck }) }}>Pre OPSO</label>

                                        </span>

                                        <span className='checkbox-label-container'>

                                            <input type='checkbox' className='check-box-scss' checked={this.state.isPostCheck}
                                                onChange={() => { this.setState({ isPostCheck: !this.state.isPostCheck }) }} />

                                            <label className='checkbox-label'
                                                onClick={() => { this.setState({ isPostCheck: !this.state.isPostCheck }) }}>Post OPSO</label>

                                        </span>


                                        {
                                            this.props.heading === 'absolute' ?
                                                null
                                                :
                                                <>
                                                    <span className='checkbox-label-container'>

                                                        <input type='checkbox' className='check-box-scss' checked={this.state.isCategory}
                                                            onChange={() => { this.setState({ isCategory: !this.state.isCategory }) }} />

                                                        <label className='checkbox-label'
                                                            onClick={() => { this.setState({ isCategory: !this.state.isCategory }) }}>Category</label>

                                                    </span>

                                                    <span className='checkbox-label-container'>

                                                        <input type='checkbox' className='check-box-scss' checked={this.state.isBrand}
                                                            onChange={() => { this.setState({ isBrand: !this.state.isBrand }) }} />

                                                        <label className='checkbox-label'
                                                            onClick={() => { this.setState({ isBrand: !this.state.isBrand }) }}>Brand</label>

                                                    </span>
                                                </>
                                        }


                                    </div>

                                </ClickAwayListener>

                                :
                                null
                        }

                    </span>

                </div>

                <div className='table-container'>

                    <table className='main-table'>

                        <thead className='bottom-border-for-row'>

                            <tr className='heading-titles'>

                                <th rowSpan="2" style={{ color: 'white', width: '200px' }}>Amber</th>

                                <th className='amber-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Amber</th>

                                <th className='green-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Green</th>

                                <th className='red-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Red</th>

                                <th className='grand-total-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Grand Total</th>

                                <th className='amber-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Amber</th>

                                <th className='green-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Green</th>

                                <th className='red-head' colSpan={this.state.isPostCheck && this.state.isPreCheck ? "2" : "1"}>Red</th>

                            </tr>

                            <tr className='pre-post-heading'>

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                                {this.state.isPreCheck ? <th className='pre-data-cell'>Pre</th> : null}

                                {this.state.isPostCheck ? <th>Post</th> : null}

                            </tr>

                        </thead>

                        <tbody>

                            {
                                this.props.preAndPostOpso ?
                                    this.props.preAndPostOpso.map((item, index) => (

                                        <React.Fragment key={index}>

                                            {this.state.isCategory ?
                                                <tr className='tbody-row bottom-border-for-row'>

                                                    <td className='category-cell'
                                                        onClick={() => { this.setState({ openIndex: index, dropRow: !this.state.dropRow }) }}>
                                                        {item.Category}</td>

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(item.Amber.Pre?.toFixed(0))}</td> : null}

                                                    {this.state.isPostCheck ? <td>{valueConverter_2(item.Amber.Post?.toFixed(0))}</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(item.Green.Pre?.toFixed(0))}</td> : null}

                                                    {this.state.isPostCheck ? <td>{valueConverter_2(item.Green.Post?.toFixed(0))}</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(item.Red.Pre?.toFixed(0))}</td> : null}

                                                    {this.state.isPostCheck ? <td>{valueConverter_2(item.Red.Post?.toFixed(0))}</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(item.GrandTotal.Pre?.toFixed(0))}</td> : null}

                                                    {this.state.isPostCheck ? <td>{valueConverter_2(item.GrandTotal.Post?.toFixed(0))}</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{item.AmberPercentage.Pre?.toFixed(2)}%</td> : null}

                                                    {this.state.isPostCheck ? <td>{item.AmberPercentage.Post?.toFixed(2)}%</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{item.GreenPercentage.Pre?.toFixed(2)}%</td> : null}

                                                    {this.state.isPostCheck ? <td>{item.GreenPercentage.Post?.toFixed(2)}%</td> : null}

                                                    {this.state.isPreCheck ? <td className='pre-data-cell'>{item.RedPercentage.Pre?.toFixed(2)}%</td> : null}

                                                    {this.state.isPostCheck ? <td>{item.RedPercentage.Post?.toFixed(2)}%</td> : null}

                                                </tr>
                                                : null}

                                            {
                                                this.state.openIndex === index && this.state.dropRow ?
                                                    item.Brands ?
                                                        item.Brands.map((elm, brandIndex) => {       // eslint-disable-line

                                                            if (this.state.isBrand && this.props.heading === 'count') {         // Brand row for Count Activities

                                                                return (

                                                                    <tr key={brandIndex+elm.Brand} className={`brand-row ${item.Brands.length - 1 === brandIndex ? 'row-border' : null}`}>

                                                                        <td className='brand-cell'><span className='brand-text'>{elm.Brand}</span></td>

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Amber.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Amber.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Green.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Green.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Red.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Red.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.GrandTotal.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.GrandTotal.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.AmberPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.AmberPercentage.Post?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.GreenPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.GreenPercentage.Post?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.RedPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.RedPercentage.Post?.toFixed(2)}%</td> : null}

                                                                    </tr>
                                                                )
                                                            }
                                                            else if (this.props.heading === 'absolute') {       // Brand row for Absolute spend

                                                                return (

                                                                    <tr key={brandIndex+elm.Brand} className={`brand-row ${item.Brands.length - 1 === brandIndex ? 'row-border' : null}`}>

                                                                        <td className='brand-cell'><span className='brand-text'>{elm.Brand}</span></td>

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Amber.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Amber.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Green.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Green.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.Red.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.Red.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{valueConverter_2(elm.GrandTotal.Pre?.toFixed(0))}</td> : null}

                                                                        {this.state.isPostCheck ? <td>{valueConverter_2(elm.GrandTotal.Post?.toFixed(0))}</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.AmberPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.AmberPercentage.Post?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.GreenPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.GreenPercentage.Post?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPreCheck ? <td className='pre-data-cell'>{elm.RedPercentage.Pre?.toFixed(2)}%</td> : null}

                                                                        {this.state.isPostCheck ? <td>{elm.RedPercentage.Post?.toFixed(2)}%</td> : null}

                                                                    </tr>
                                                                )
                                                            }


                                                        })
                                                        :
                                                        null
                                                    :
                                                    null
                                            }

                                        </React.Fragment>
                                    ))
                                    :
                                    null
                            }

                        </tbody>

                    </table>

                </div>

                {
                    this.props.heading === 'absolute' ?
                        null
                        :

                        <div className='disclaimer'>
                            * An activity can be opened on multiple brands in PRAT. Accordingly, count of activities at
                            category level for both Pre and Post OPSO does not always show the exact summation of count
                            of activities at brand level belong to that category.
                        </div>

                }

            </div>
        );
    }
}

export default PreAndPostOpsoTable;
